<template>
<div>
  <h1>OTPTest</h1>
  <otp-block-input v-model="otp" @requestNewOTP="requestNewOTP"></otp-block-input>
  <p>model: {{otp}}</p>
</div>
</template>

<script>
export default {
  data: () => ({
    otp: ''
  }),
  methods: {
    requestNewOTP () {
      alert('requested')
    }
  }
}
</script>

<style lang="scss">
</style>
